export default "__VITE_ASSET__BwWNQrZd__"